export const VAC_OPTIONS = [
  { value: '100', label: 'Conventional' },
  { value: '101', label: 'Genadyne' },
  { value: '102', label: 'Other' },
  { value: '103', label: 'Pico' },
  { value: '104', label: 'Smith&Nephew' },
  { value: '105', label: 'Uno' },
]

export const HOME_OPTIONS = [
  { value: '200', label: 'Ascot' },
  { value: '201', label: 'City Hospital' },
  { value: '202', label: 'Capital Hospital' },
  { value: '203', label: 'Durdoc Hospital' },
  { value: '204', label: 'Crompton Hospital' },
  { value: '205', label: 'Entabeni Hospital' },
  { value: '206', label: 'eThekwini Hospital' },
  { value: '207', label: 'Parklands' },
  { value: '208', label: 'SAN' },
  { value: '209', label: 'Umhlanga' },
  { value: '210', label: 'Durdoc Rooms' },
  { value: '211', label: 'Beacon Rock' },
  { value: '212', label: 'Other1' },
  { value: '213', label: 'Other2' },
  { value: '214', label: 'Other3' },
  { value: '215', label: 'Home' },
]

export const getHomeLabel = (value) => {
  const option = HOME_OPTIONS.find((item) => item.value === value)
  return option ? option.label : 'error'
}

export const getVacLabel = (value) => {
  const option = VAC_OPTIONS.find((item) => item.value === value)
  return option ? option.label : 'error'
}